
import React from 'react';
import MainLayout from '@/components/layout/MainLayout';

export let lastUpdated: string = "Jan 04, 2025";
export let companyName: string = 'CanXP.AI';
export let contactEmail: string = 'hello@canxp.ai';
export let companyAddress: string = '77 Westmorland Street, Suite 300, Fredericton, New Brunswick, Canada, E3B-6Z3';

const Eula = () => {
  return (
    <MainLayout>
      <div className="container max-w-4xl mx-auto py-8 px-4">
        <h1 className="text-3xl font-bold mb-6">End User License Agreement</h1>
        <div className="prose prose-sm dark:prose-invert">
          <p>This End User License Agreement ("EULA") is a legal agreement between you ("User") and CanXP.ai ("we," "us," or "our") governing your access to and use of our AI chat services (the "Service") in Canada.</p>

          <p>Effective Date: {lastUpdated}</p>

          <h2 className="text-xl font-semibold mt-6 mb-3">1. License Grant</h2>
          <p>CanXP.ai grants you a limited, non-exclusive, non-transferable, revocable license to access and use the Service for personal or business purposes, in accordance with this EULA.</p>

          <h2 className="text-xl font-semibold mt-6 mb-3">2. Restrictions</h2>
          <p>You may not:</p>
          <ul className="list-disc ml-6 mb-4">
            <li>Modify, reverse engineer, or decompile the Service.</li>
            <li>Use the Service to infringe on intellectual property rights or violate any applicable laws.</li>
            <li>Use the Service for any illegal, abusive, or harmful purposes.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-3">3. User Data and Privacy</h2>

          <h3 className="text-lg font-semibold mt-4 mb-2">3.1 Data Storage and Security</h3>
          <p>We are committed to safeguarding your personal information. All user data collected through the Service is securely stored and processed within Canada in compliance with applicable Canadian data privacy laws, including PIPEDA.</p>

          <h3 className="text-lg font-semibold mt-4 mb-2">3.2 Data Usage</h3>
          <p>We use your data to improve our Service and provide personalized experiences. For more details, please review our <a href="/data-residency">Data Residency</a> page.</p>

          <h3 className="text-lg font-semibold mt-4 mb-2">3.3 Third-Party Access</h3>
          <p>We do not share your personal data with third parties unless required by law or with your explicit consent.</p>

          <h2 className="text-xl font-semibold mt-6 mb-3">4. Intellectual Property</h2>
          <p>All intellectual property rights in the Service, including but not limited to its content, software, and trademarks, are owned by CanXP.ai or its licensors. This EULA does not grant you any ownership rights.</p>

          <h2 className="text-xl font-semibold mt-6 mb-3">5. Termination</h2>
          <p>We reserve the right to suspend or terminate your access to the Service if you violate any terms of this EULA.</p>

          <h2 className="text-xl font-semibold mt-6 mb-3">6. Limitation of Liability</h2>
          <p>To the fullest extent permitted by law, CanXP.ai is not liable for any indirect, incidental, or consequential damages arising from your use of the Service.</p>

          <h2 className="text-xl font-semibold mt-6 mb-3">7. Governing Law</h2>
          <p>This EULA shall be governed by and construed in accordance with the laws of the Province of New Brunswick, Canada, without regard to its conflict of law principles.</p>

          <h2 className="text-xl font-semibold mt-6 mb-3">8. Amendments</h2>
          <p>We may update this EULA from time to time. Any changes will be posted on our website, and your continued use of the Service constitutes acceptance of the updated terms.</p>

          <h2 className="text-xl font-semibold mt-6 mb-3">9. Contact Information</h2>
          <p>If you have any questions about this Agreement, please contact us at:</p>
          <p><strong>{companyName}</strong></p>
          <p>{companyAddress}</p>
          <p><a href={`mailto:${contactEmail}`}>{contactEmail}</a></p>
        </div>

      </div>
    </MainLayout>
  );
};

export default Eula;
